import styled from "styled-components";
import { colors } from "../../helpers/functions";

export const SubscribeStyled = styled.div`
    background-color: rgb(${colors.blanco_huevo});
    width: 100%;
    padding-top: 10vw;
    padding-bottom: 13vw;
    .image{
        width: 100%;
        margin-top: 13vw;
        img{
            width: 100%;
            float: left;
        }
    }
    .inner{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .suscribite{
            font-weight: 900;
            font-size: 11.8vw;
            line-height: 11.8vw;
            color: rgb(${colors.marron_tierra});
        }
        .nuestro{
            font-weight: 800;
            font-size: 6.9vw;
            line-height: 6.9vw;
            color: rgb(${colors.marron_tierra});
        }
        .bajada{
            width: 80vw;
            margin-top: 2vw;
            font-size: 3.8vw;
            line-height: 4.8vw;
            font-weight: 600;
            color: rgb(${colors.marron_tierra});
            text-align: center;
        }
        .form{
            width: 80vw;
            margin-top: 3.5vw;
            .fields{
                .field{
                    input{
                        font-weight: 500;
                        width: 100%;
                        padding: 3vw;
                        font-size: 4.5vw;
                        line-height: 4.5vw;
                        border-radius: 12px;
                        border: 2px solid rgb(${colors.marron_tierra});
                        outline: 0;
                        &.error{
                            border-color: red;
                        }
                    }
                }
            }
            
        }
        .actions{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 3.5vw;
            .loader{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 56px;
                svg{
                    color: rgba(${colors.verde_acelga}, 1);
                }
            }
            .bt_subscribe{
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                -webkit-box-shadow: -8px 8px 0px 3px rgba(0,0,0,1);
                -moz-box-shadow: -8px 8px 0px 3px rgba(0,0,0,1);
                box-shadow: -8px 8px 0px 3px rgba(0,0,0,1);
                background-color: rgb(${colors.azul_agua});
                color: #FFFFFF;
                border: 2px solid #000000;
                font-size: 5vw;
                line-height: 5vw;
                font-weight: 800;
                text-transform: uppercase;
                padding-left: 5vw;
                padding-right: 5vw;
                height: 13vw;
            }
        }
    }
`